import * as helpers from './helpers'

//import { startWs, stopWs } from "../ws"



const defaultListReducerForAtskaite = helpers.createListReducer({listViewName: 'atskaite', actionsName: 'atskaite'})
const defaultEditReducerForAtskaite = helpers.createEditReducer({editViewName: 'atskaite', actionsName: 'atskaite'})

export const atskaites = (state = helpers.listEditGetInitialState(), {type, payload, reqId}) => {
    //overwrite or add custom actions catches here

    const stateAfterList = defaultListReducerForAtskaite({state, type, payload, reqId})
    return defaultEditReducerForAtskaite({state : stateAfterList, type, payload, reqId})
}
